import React from 'react';
import { Sparkles, ArrowDown, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Hero = () => {
  const features = [
    "Devis gratuit sous 24h",
    "Intervention rapide en Charente-Maritime",
    "Crédit d'impôt 50 % pour les particuliers"
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-orange-50">
      {/* Decorative elements — static (no infinite animation). Animating
          large blur-3xl filters causes continuous GPU repaints and visible jank
          during scroll. Keep the orbs as decorative but stationary. */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[hsl(207,90%,54%)] rounded-full opacity-10 blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[hsl(32,95%,55%)] rounded-full opacity-10 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-blue-100 to-orange-100 rounded-full opacity-30 blur-3xl" />
      </div>

      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-32">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-blue-100 rounded-full px-4 py-2 mb-8 animate-fade-in-up shadow-sm">
            <Sparkles className="w-4 h-4 text-[hsl(32,95%,55%)]" />
            <span className="text-sm font-medium text-gray-700">Experts en nettoyage depuis + de 5 ans</span>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            Nettoyage de vitres{' '}
            <span className="text-gradient">& ménage professionnel</span>
            <br />
            à Royan
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            SMT Services, votre <span className="font-semibold text-[hsl(207,90%,54%)]">spécialiste du nettoyage de vitres et du ménage</span> à Royan et dans toute la Charente-Maritime. Pour <strong>particuliers et professionnels</strong> — devis gratuit, intervention rapide, et <strong>50 % de crédit d'impôt</strong> sur les prestations à domicile.
          </p>

          {/* Features list */}
          <div className="flex flex-wrap justify-center gap-4 mb-10 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 bg-white/60 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm">
                <CheckCircle className="w-4 h-4 text-green-500" />
                <span className="text-sm text-gray-700">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Button
              asChild
              size="lg"
              className="bg-[hsl(207,90%,54%)] hover:bg-[hsl(207,90%,44%)] text-white font-semibold px-8 py-6 text-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <a href="#reservation">Demander un devis gratuit</a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-2 border-gray-300 hover:border-[hsl(32,95%,55%)] text-gray-700 hover:text-[hsl(32,95%,55%)] font-semibold px-8 py-6 text-lg transition-all duration-300"
            >
              <a href="#services">Découvrir nos services</a>
            </Button>
          </div>

          {/* Scroll indicator */}
          <div className="mt-16 animate-bounce">
            <a href="#services" className="inline-flex flex-col items-center text-gray-400 hover:text-[hsl(207,90%,54%)] transition-colors">
              <span className="text-sm mb-2">Découvrir</span>
              <ArrowDown className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
